import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=506a116d&scoped=true"
import script from "./Risk.vue?vue&type=script&lang=js"
export * from "./Risk.vue?vue&type=script&lang=js"
import style0 from "./Risk.vue?vue&type=style&index=0&id=506a116d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a116d",
  null
  
)

export default component.exports